import { IPedigreeGraphLink } from './PedigreeService';

export enum ERelationType {
  PARENT = 'parent',
  PARTNER = 'partner',
  CONSAGUINITY = 'consaguinity',
  DIVORCED = 'divorced',
  CONSAGUINITY_DIVORCED = 'consaguinity_divorced',
  SPERM_DONOR = 'sperm-donor',
  OVUM_DONOR = 'ovum-donor',
}

export default class PedigreeLink implements Partial<IPedigreeGraphLink> {
  public relationType: ERelationType = ERelationType.PARENT;

  public override = false;

  constructor(public id: number, public source: number, public target: number) {
  }

  public setRelationType(relationType: ERelationType) {
    this.relationType = relationType;

    return this;
  }

  public setOverride(override: boolean) {
    this.override = override;

    return this;
  }
}
